import { Route, Routes } from "react-router-dom";
import {
  Main,
  Contacts,
  Impressum,
  NetworkitRules,
  PrivacyPolicy,
} from "pages";
import Layout from "common/components/Layouts/Layout";

function Root() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Main />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="network-it-rules" element={<NetworkitRules />} />
        <Route path="*" element={<Main />} />
      </Route>
    </Routes>
  );
}

export default Root;
